import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import AuthHeader from "../components/common/AuthHeader";
import { useAuthStore } from "src/store/authStore";
import { useGetMe } from "src/hooks/useAuth";
import AuthFooter from "src/components/common/AuthFooter";

export default function ProtectedLayout() {
  const { authToken, setUser } = useAuthStore();

  // Fetch (and keep fresh) the current user profile.
  // React Query caches the result; staleTime = 5 min so it won't spam /auth/me.
  // The hook is a no-op when authToken is absent (enabled: !!authToken).
  const { data: user } = useGetMe();

  // Sync React Query result into Zustand so AuthHeader and other
  // store consumers always see the latest profile.
  useEffect(() => {
    if (user) setUser(user);
  }, [user, setUser]);

  if (!authToken) {
    return <Navigate to="/users/sign_in" replace />;
  }

  return (
      <>
          <AuthHeader />
          <section className="d-flex flex-column flex-fill overflow-hidden">
              <Outlet />
          </section>
          <AuthFooter />
      </>
  );
}
